export function isPossibleToUseWorker() {
    return !!window.Worker && !!window.URL && !!window.Blob
}

/**
 * Create worker from function without dependencies !!
 * @param fn function without dependencies
 * @returns {Worker}
 */
export function createWorkerFromFunction(fn) {
    return new Worker(
        window.URL.createObjectURL(
            new Blob([
                    'self.onmessage = function(wrk) {' +
                    'var f = ' + Function.toString.call(fn) + ';' +
                    'self.postMessage(f.apply(f, wrk.data.args));' +
                    '};'
                ],
                {type: 'text/javascript'}
            )
        )
    )
}



// WEBPACK FOOTER //
// ./web/js/json2csv/utils.js